import { AbstractFilter } from './abstractFilter';

export class CheckboxFilter extends AbstractFilter {
  getDisplayName(filterValue = {}) {
    const values = [];
    const { value } = filterValue;
    if (!Array.isArray(value) || !Array.isArray(this.filter?.options)) return '';
    value.forEach((v) => {
      const match = this.filter.options.find((x) => x.key === v);
      if (match) values.push(match.name);
    });
    return values.join(', ');
  }
}
